var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('text-bubble', {
    staticClass: "text-left",
    scopedSlots: _vm._u([{
      key: "mms",
      fn: function () {
        return [_c('v-responsive', {
          staticClass: "relative",
          style: {
            'background-color': _vm.order.skin.page_background_color
          },
          attrs: {
            "aspect-ratio": 16 / 9
          }
        }, [_c('v-card', {
          staticClass: "absolute",
          staticStyle: {
            "z-index": "1",
            "left": "17.1875%",
            "top": "8.3333%",
            "width": "65.625%"
          },
          attrs: {
            "tile": ""
          }
        }, [_c('v-responsive', {
          staticClass: "relative",
          attrs: {
            "aspect-ratio": 7 / 5
          }
        }, [_c('v-responsive', {
          staticClass: "absolute overflow-visible",
          staticStyle: {
            "top": "-20%",
            "width": "100%"
          },
          attrs: {
            "aspect-ratio": 1
          }
        }, [_c('envelope', {
          staticClass: "fill-height",
          attrs: {
            "skin": _vm.order.skin,
            "from": _vm.from,
            "to": _vm.to
          }
        })], 1)], 1)], 1), _c('v-img', {
          attrs: {
            "src": _vm.img
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "preserve-newlines",
    domProps: {
      "innerHTML": _vm._s(_vm.skin.email_subject)
    }
  }), _vm.toTxt ? _c('div', [_vm._v("To: "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.toTxt)
    }
  })]) : _vm._e(), _vm.fromTxt ? _c('div', [_vm._v("From: "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.fromTxt)
    }
  })]) : _vm._e(), _vm.followUpMsg ? _c('div', [_c('br'), _c('span', {
    staticClass: "preserve-newlines"
  }, [_vm._v(_vm._s(_vm.followUpMsg))])]) : _vm._e(), _c('br'), _c('div', {
    staticStyle: {
      "word-break": "normal"
    }
  }, [_vm._v(" Follow this link to " + _vm._s(_vm.order.type == 'INVITATION' ? 'see more details and RSVP' : 'open the card') + " ")]), _c('a', {
    staticClass: "white--text",
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('preview');
      }
    }
  }, [_vm._v(" https://ellacard.com/open/" + _vm._s(_vm.orderId || '…') + " ")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }